/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkconnected2Inputs */

const en_profilelinkconnected2 = /** @type {(inputs: Profilelinkconnected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected profiles`)
};

const de_profilelinkconnected2 = /** @type {(inputs: Profilelinkconnected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbundene Profile`)
};

/**
* | output |
* | --- |
* | "Connected profiles" |
*
* @param {Profilelinkconnected2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkconnected2 = /** @type {((inputs?: Profilelinkconnected2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkconnected2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkconnected2(inputs)
	return de_profilelinkconnected2(inputs)
});
export { profilelinkconnected2 as "profileLinkConnected" }